export const INTERVALO_RELOGIO_NOTIFICACAO_MS = 30_000;
export const VARIAVEL_ALTURA_BANNER_LEMBRETE = '--altura-notificacao-lembrete';
export const DURACAO_ENTRADA_CARD_LEMBRETE_MS = 380;
export const DURACAO_SAIDA_CARD_LEMBRETE_MS = 220;
export const DURACAO_ENTRADA_BANNER_LEMBRETE_MS = 420;
export const DURACAO_SAIDA_BANNER_LEMBRETE_MS = 220;
